import * as exDatatable from './mount';
import type { TypeManagerApi, TypeManagerConfig } from './mount';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLTableElement {
        datatable(config?: TypeManagerConfig): TypeManagerApi | undefined;
    }
}

// ----------------------------------------------------------------------------

HTMLTableElement.prototype.datatable = function (config?: TypeManagerConfig): TypeManagerApi | undefined {
    return exDatatable.mount(this, config);
};
